import { IProduct } from '../../../IProduct';
import { P00039DataRxTxIndex } from '../../P00039Sync';
import { getPoolMasterClass } from '../../../../ECoSystemsHelper';
import { Pool } from '../../../../../../apis/pool.api';

export function P00076InstallationFinish(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  const master = getPoolMasterClass(pool);
  const presence = master?.hasProduct(pool, productClass) ?? 0;
  editValue(
    P00039DataRxTxIndex.Constance_Installation,
    'coIConfigurationProduit',
    presence != 0,
    null,
    productClass,
  );
}
